import { initializeApp } from 'firebase/app';
import { connectDatabaseEmulator, getDatabase } from 'firebase/database';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';


// Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { getFunctions, connectFunctionsEmulator, Functions } from 'firebase/functions';
import { getAnalytics, Analytics } from 'firebase/analytics';

import { isLocal, isTest } from './env';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_FIREBASE_DB_URL,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};


// Initialize Firebase only if config is present (or at least apiKey and databaseURL)
// This prevents crashes in dev environments without these vars
let app;
let database: ReturnType<typeof getDatabase> | null = null;
let auth: ReturnType<typeof getAuth>;
let firestore: ReturnType<typeof getFirestore> | null = null;
let functions: Functions = {} as Functions;
let analytics: Analytics | null = null;

if (firebaseConfig.apiKey && firebaseConfig.databaseURL) {
  try {
    app = initializeApp(firebaseConfig);
    database = getDatabase(app);
    auth = getAuth(app);
    functions = getFunctions(app);
    firestore = getFirestore(app);
    analytics = getAnalytics(app);

    console.log("Decision - local or not", { "hostname": window.location.hostname, "node-env": process.env.NODE_ENV, "isLocal": isLocal, "isTest": isTest })

    // Check if running locally (e.g., via environment variable)
    if (isLocal || isTest) {
      if (firestore) {
        connectFirestoreEmulator(firestore, '127.0.0.1', 8080);
        console.log("Firestore emulator connected successfully")
      }
      connectDatabaseEmulator(database, "localhost", 9000);
      connectAuthEmulator(auth, "http://localhost:9099");
      connectFunctionsEmulator(functions, "localhost", 5001);
      console.log("Emulators connected successfully")
    }

    console.log("Firebase initialized successfully");
  } catch (error) {
    console.error("Firebase initialization failed:", error);
  }
} else {
  console.warn("Firebase configuration missing (VITE_FIREBASE_API_KEY or VITE_FIREBASE_DB_URL). Realtime logging disabled.");
}

export { database, auth, firestore, functions, analytics };